import { useContext } from "react";
import { useMsal } from "@azure/msal-react";
import Button from '@material-ui/core/Button';
import { LanguageContext } from "../Helpers/Context";

export const SignOutButton = () => {
    const { instance, accounts } = useMsal();
    const { dictionary } = useContext(LanguageContext);

    //console.log("account", accounts);

    const handleLogout = () => {
        instance.logoutPopup({
            postLogoutRedirectUri: "/",
            mainWindowRedirectUri: "/"
        });
    }
    return (
        <Button variant="outlined" size="small" color="inherit" onClick={() => handleLogout()}>{dictionary.signOut} {accounts[0].name}</Button>
    )
}